import { __extends } from '../../node_modules/tslib/tslib.es6.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import '../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../node_modules/lit-element/lit-element.js';
import { version } from '../../package.json.js';

var PvdBaseComponent = /** @class */ (function (_super) {
    __extends(PvdBaseComponent, _super);
    function PvdBaseComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(PvdBaseComponent, "namespace", {
        get: function () {
            return this._namespace || 'pvd';
        },
        set: function (value) {
            this._namespace = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdBaseComponent, "customElementName", {
        get: function () {
            return this._customElementName;
        },
        set: function (value) {
            this._customElementName = value;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Define Providence components within the CustomElementRegistry.
     * @param namespace a string used to namespace components in order to avoid conflicting with other Providence versions
     * @see {@link https://providence.fmr.com/getting-started-for-developers/developer-overview.html|Getting started for developers}
     */
    PvdBaseComponent.defineCustomElement = function (namespace, customElementClass) {
        if (namespace === void 0) { namespace = 'pvd'; }
        if (customElementClass === void 0) { customElementClass = this; }
        // Warn that the required 'componentName' property is missing so that it is
        // easier to identify these issues during development
        if (!customElementClass.componentName) {
            console.warn("Missing required static 'componentName' property");
        }
        var customElementName = "".concat(namespace, "-").concat(customElementClass.componentName);
        this.namespace = namespace;
        this.customElementName = customElementName; // Save the customElement name so it can be referenced later
        if (!PvdBaseComponent.customElementDefined(customElementName)) {
            customElements.define(customElementName, customElementClass);
        }
    };
    PvdBaseComponent.customElementDefined = function (customElementName) {
        return customElements.get(customElementName) !== undefined;
    };
    PvdBaseComponent.generateRandomNumber = function (max) {
        if (max === void 0) { max = 1000000000000; }
        return Math.floor(Math.random() * Math.floor(max));
    };
    /**
     * Determine if a provided attribute has changed and validate the new value
     * if it has changed
     * @param validAttributes
     */
    PvdBaseComponent.hasChanged = function (validAttributes) {
        var values = function (obj) {
            var arr = [];
            for (var idx in obj) {
                arr.push(obj[idx]);
            }
            return arr;
        };
        var validAttributesArray = !Array.isArray(validAttributes)
            ? values(validAttributes)
            : validAttributes;
        return {
            hasChanged: function (val, oldVal) {
                var isValid = function (valid) { return val === valid; };
                if (val === oldVal) {
                    return false;
                }
                if (!validAttributesArray.some(isValid)) {
                    console.warn("'".concat(val, "' is an invalid attribute value (expected one of: ").concat(validAttributesArray.join(', '), ")"));
                }
                return true;
            },
        };
    };
    /**
     * Define conversions for going from an attribute to a property and vice versa.
     * @param attributeName name of the boolean attribute
     */
    PvdBaseComponent.booleanAttribute = function (attributeName) {
        return {
            converter: {
                fromAttribute: function (val) {
                    var attrVal = val ? val.trim() : val;
                    return attrVal === '' || attrVal === 'true' || attrVal === attributeName;
                },
                toAttribute: function (val) {
                    return val;
                },
            },
        };
    };
    PvdBaseComponent.prototype.firstUpdated = function (changedProperties) {
        _super.prototype.firstUpdated.call(this, changedProperties);
        this.dispatchEvent(new CustomEvent('pvd-component-ready', {
            bubbles: true,
            detail: {
                component: PvdBaseComponent.customElementName,
            },
        }));
    };
    PvdBaseComponent.prototype.updated = function (changedProperties) {
        _super.prototype.updated.call(this, changedProperties);
        this.dispatchEvent(new CustomEvent('pvd-component-updated', {
            bubbles: true,
            detail: {
                component: PvdBaseComponent.customElementName,
            },
        }));
    };
    Object.defineProperty(PvdBaseComponent.prototype, "className", {
        /**
         * className getter works in tandem with a component's classMap getter.
         */
        get: function () {
            return this.createClassName();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdBaseComponent.prototype, "classMap", {
        // to be overwritten by the subclass
        get: function () {
            return {};
        },
        enumerable: false,
        configurable: true
    });
    PvdBaseComponent.prototype.createClassName = function (classMap) {
        if (classMap === void 0) { classMap = this.classMap; }
        var classList = '';
        for (var prop in classMap) {
            var modifierPrefix = classMap.modifierPrefix || false;
            if (typeof classMap[prop] === 'object') {
                var className = classMap[prop].className;
                if (classMap[prop].modifierPrefix !== undefined) {
                    modifierPrefix = classMap[prop].modifierPrefix;
                }
                if (classMap[prop].condition) {
                    if (typeof className === 'object') {
                        for (var singleClass in className) {
                            classList = this.addClass(classList, className[singleClass], modifierPrefix);
                        }
                    }
                    else {
                        classList = this.addClass(classList, className, modifierPrefix);
                    }
                }
            }
            else {
                var className = classMap[prop];
                switch (prop) {
                    case 'default':
                        classList = this.addClass(classList, className);
                        break;
                    default:
                        if (this[prop]) {
                            classList = this.addClass(classList, className, modifierPrefix);
                        }
                        break;
                }
            }
        }
        return classList;
    };
    PvdBaseComponent.prototype.addClass = function (classList, newClass, modifierPrefix) {
        if (modifierPrefix === void 0) { modifierPrefix = false; }
        newClass = modifierPrefix ? "".concat(modifierPrefix, "--").concat(newClass) : newClass;
        return classList.length === 0 ? newClass : "".concat(classList, " ").concat(newClass);
    };
    /**
     * Returns where to render the component's template.
     * It is configured by the shadowDOM property on the component definition.
     */
    PvdBaseComponent.prototype.createRenderRoot = function () {
        if (this.constructor.shadowDOM) {
            return _super.prototype.createRenderRoot.call(this);
        }
        return this;
    };
    /**
     * Clone and dispatch and event that doesn't bubble by default
     * @param e event where `event.bubbles` === `false`
     */
    PvdBaseComponent.prototype.bubbleEvent = function (e) {
        // grabbing the HTML element of 'this' instance
        this.dispatchEvent(new Event(e.type, e));
    };
    /**
     * For a11y attributes, if the value is set to 'false' the attribute should be completely removed off the DOM, not aria-*="false"
     * This function, with the help of ifDefined(), will return undefined to remove a11y props with a `false` value off the DOM
     * @param val property that you are validating where if its false, gets set to undefined
     */
    PvdBaseComponent.prototype.a11yBoolean = function (val) {
        return val ? true : undefined;
    };
    /**
     * For custom attributes, this function allows custom attributes to be set/removed on specific elements
     * @param newAttr the object of attributes that are needing to be added
     * @param prevAttr optional, if there were custom attributes added prior, this is used to determine if attributes need to be removed/updated
     * @param propertyMap a mapping of 'protected' attributes that tie into properties of a element in a web component
     * @param targetElement the element that the attributes should be added/removed from
     */
    PvdBaseComponent.prototype.setNativeAttributes = function (newAttr, propertyMap, targetElement, prevAttr) {
        if (newAttr && targetElement) {
            if (prevAttr && propertyMap) {
                // removes attributes that are not being applied via props
                this.removePreviousAttributes(prevAttr, propertyMap, targetElement);
            }
            Object.keys(newAttr).map(function (attribute) {
                // if the attribute is in the 'protected' attribute map, throw warning and do not add
                if (propertyMap.get(attribute)) {
                    console.warn("use '".concat(propertyMap.get(attribute), "' to set the '").concat(attribute, "' attribute"));
                }
                else {
                    // double == here to be inclusive of `null` and `undefined`
                    if (typeof newAttr[attribute] === 'boolean' || newAttr[attribute] == undefined) {
                        // if the attribute is a boolean, and is true, add attribute using empty strings as value
                        // otherwise, remove attribute
                        newAttr[attribute] === true
                            ? targetElement.setAttribute(attribute, '')
                            : targetElement.removeAttribute(attribute);
                    }
                    else {
                        // adds new attribute to the target element
                        targetElement.setAttribute(attribute, newAttr[attribute].toString());
                    }
                }
            });
        }
    };
    /**
     * Logic used to remove attributes that are not being placed on an element via props
     * @param prevAttr if there were custom attributes added prior, this is used to determine if attributes need to be removed/updated
     * @param propertyMap a mapping of 'protected' attributes that tie into properties of a element in a web component
     * @param targetElement the element that the attributes should be removed from
     */
    PvdBaseComponent.prototype.removePreviousAttributes = function (prevAttr, propertyMap, targetElement) {
        Object.keys(prevAttr).map(function (attribute) {
            // if the attribute is not in the 'protected' attribute map, remove
            if (!propertyMap.get(attribute)) {
                targetElement.removeAttribute(attribute);
            }
        });
    };
    PvdBaseComponent.shadowDOM = false;
    PvdBaseComponent.version = version;
    return PvdBaseComponent;
}(s));

export { PvdBaseComponent };
